<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">

          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Performance Reviews</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Performance Reviews</li>
                </ul>
              </div>
              
            </div>
          </div>
          <!-- /Page Header -->
                              <div class="row">
                                <div class="col-md-12">
                                   <div class="card">
                                    <div class="card-header">
                                      <div class="d-flex justify-content-between">
                                        <h4 class="card-title mb-0">Perfomance Reviews</h4>
                                        
                                      </div>
                                    </div>
                              <div class="card-body">
                               <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group form-focus select-focus">
                <select
                  class="form-control"
                  style="height: 55px !important;"
                  v-model="periodId"
                >
                  <option>Select Period</option>
                  <option
                    v-for="item in periods"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</option
                  >
                </select>
                <label class="focus-label">Select Period</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <a
                @click="getReviews()"
                class="btn btn-success"
                :disabled="loading"
              >
                Search
              </a>
              <a
                @click="exportReview()"
                class="btn btn-secondary"
                :disabled="loading"
              >
                Export
              </a>
            </div>
          </div>
          <!-- /Search Filter -->
                              <!----Datatable-->
                                <div class="row">
                                    <div class="col-md-12">
                                    <div class="table-responsive">
                                    
                                  <v-data-table
                                    :headers="headers"
                                    :items="reviews"
                                    sort-by=""
                                    class="elevation-1"
                                  >
                                    <template v-slot:[`item.profile`]="{ item }">
                                      <h2 class="table-avatar blue-link">
                                        <router-link :to="{name: 'hrReviewDetail', params: {id: item.id}}" class="avatar"><img alt=""
                                                            src="~@/assets/profiles/avatar-02.jpg" v-if="!item.employee.passportPhoto">
                                                            <img alt="" :src="media + item.employee.passportPhoto" width="38" v-if="item.employee.passportPhoto"
                                        /></router-link>
                                        <router-link :to="{name: 'hrReviewDetail', params: {id: item.id}}">{{
                                            `${item.employee.firstName} ${item.employee.lastName}`
                                            }}</router-link>
                                        </h2>
                                    </template>
                                    <template v-slot:[`item.averageSelfResult`]="{ item }">
                                      {{  `${item.averageSelfResult}%` }}
                                    </template>
                                    <template v-slot:[`item.averageManagerResult`]="{ item }">
                                      {{  `${item.averageManagerResult}%` }}
                                    </template>
                                    <template v-slot:[`item.selfSigned`]="{ item }">
                                      {{ item.employeeSignDate != '0001-01-01T00:00:00' ? new Date(item.employeeSignDate).toLocaleDateString() : 'Not yet' }}
                                    </template>
                                    <template v-slot:[`item.managerSigned`]="{ item }">
                                      {{ item.managerSignDate != '0001-01-01T00:00:00' ? new Date(item.managerSignDate).toLocaleDateString() : 'Not yet' }}
                                    </template>
                                    
                                    <template v-slot:[`item.stat`]="{ item }">
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 0"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-purple"></i> New
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 1"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Submission
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 2"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Manager Review
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 3"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Employee Acceptance
                                      </a>
                                     
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 5"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Employee Declined Rating
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 6"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Other Review
                                      </a>
                                      <!-- what comes after?? -->
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 7"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-success"></i> Completed
                                      </a>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                
                                        <div class="dropdown dropdown-action">
                                        <a
                                            href="#"
                                            class="action-icon dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-expanded="false"
                                            ><i class="material-icons">more_vert</i></a
                                        >
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <router-link :to="{name: 'hrReviewDetail', params: {id: item.id}}"
                                            class="dropdown-item"
                                            
                                            ><i class="fa fa-pencil m-r-5"></i> Details</router-link
                                            >
                                            <!-- display modal to choose? -->
                                            <a v-if="item.status === 5"
                                              href="#"
                                              class="dropdown-item"
                                              @click.prevent="openAssignOther(item)"
                                            ><i class="fa fa-pencil m-r-5"></i> Assign Other Employee</a>
                                            <a v-if="item.status === 5"
                                              href="#"
                                              class="dropdown-item"
                                              @click.prevent="openAknModal(item)"
                                            ><i class="fa fa-pencil m-r-5"></i> Engage</a>
                                        </div>
                                        </div>
                                    </template>
                                    </v-data-table>
                                    </div>
                                    </div>
                                </div>
                                <!---/Datatable-->

                                <v-dialog v-model="dialogAssignOther" max-width="725px">
                                  <div class="modal-content">
                                    <div class="modal-header">
                                      <h5 class="modal-title">Assign Other Manager</h5>
                                      <button type="button" class="close" @click="closeAssignOther">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                    <div class="modal-body">
                                      <form>
                                        <div class="form-group">
                                          <label>Declined Reason</label>
                                          <textarea class="form-control" rows="3" readonly>{{declinedReason}}</textarea>
                                        </div>

                                        <div class="form-group">
                                          <label>Select Manager <span class="text-danger">*</span></label>
                                          <multiselectvue
                                            class="from-control"
                                            v-model="selectedManagerName"
                                            placeholder="Select Manager"
                                            :custom-label="nameOfManager"
                                            :options="managers"
                                            :searchable="true"
                                            @select="optionSelectedManager"
                                            :allow-empty="false"
                                          >
                                            <template slot="singleLabel" slot-scope="{ option }">
                                              {{ option.firstName }} {{ option.lastName }}
                                            </template>
                                          </multiselectvue>
                                        </div>

                                        <div class="submit-section">
                                          <button
                                            @click.prevent="submitAssignOther"
                                            class="btn btn-primary submit-btn"
                                            :disabled="submitted"
                                          >
                                            Assign
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </v-dialog>

                              </div>
                              </div>
                                </div>
                               
                              </div>
                              
                                
                           
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
       <!-- Decline Rating Reason Modal -->
      <div v-if="showAknModal" class="modal custom-modal show" style="display: block; background: rgba(0,0,0,0.5);" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Acknowledgement for Decline Ratings</h5>
              <button type="button" class="close" @click="showAknModal = false" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitRereview">
                <div class="form-group">
                  <label>Feedback and Observation <span class="text-danger">*</span></label>
                  <textarea
                    v-model="selectedReview.acknowledgeReason"
                    class="form-control"
                    rows="4"
                    placeholder="Enter Feedback or Observation"
                    required
                  ></textarea>
                </div>
                <div class="submit-section">
                  <button type="button" class="btn btn-secondary" @click="submitComplete">Complete</button>
                  <button type="submit" class="btn btn-primary">Re-review</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from '@/services/authenticationService';
import { performanceService } from '@/services/performanceService';
import { employeeService } from '@/services/employeeService';
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
      return {
        dialogDelete: false,
        showAknModal: false,
        headers: [
          {
            text: 'Employee',
            align: 'start',
            value: 'profile',
          },
          { text: 'Period', value: 'reviewPeriod.name' },
          {text: 'Self Rating', value: 'averageSelfResult' },
          { text: 'Manager Rating', value: 'averageManagerResult' },
          { text: 'Self Reviewed', value: 'selfSigned' },
          { text: 'Manager Reviewed', value: 'managerSigned' },
          
          { text: 'Status', value: 'stat' },
          { text: '', value: 'actions', sortable: false },
        ],
        employeeId: this.$route.params.id,
        currentUser: authenticationService.currentUserValue,
        company: authenticationService.currentOfficeValue,
        reviews: [],
        periods: [],
        periodId: 0,
        managers: [],
        selectedReview: null,
        selectedManagerName: null,
        selectedManagerId: null,
        dialogAssignOther: false,
        declinedReason: "",
        message: "",
        submitted: false,
        loading: false,
        error: ""
    }
   },
  mounted() {
      this.getReviewPeriods()
      this.loadManagers()
        if ($('.datatable').length > 0) {
            $('.datatable').DataTable({
            "bFilter": false,
            });
        }
  },

  methods: {
    openAknModal(item) {
      this.selectedReview = item
      this.showAknModal = true;
    },
    getReviews () {
      performanceService.getReviewsByPeriod(this.periodId)
          .then(
            model => { this.reviews = model
            console.log(model) },
            error => { error = error }
          )
    },
    getReviewPeriods() {
      performanceService.getReviewPeriods(this.company.id).then(
        model => {
          this.periods = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    exportReview() {
      performanceService.exportReviewsByPeriod(this.periodId).then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },
    submitRereview() {
      if (!this.selectedReview.acknowledgeReason || !this.selectedReview.acknowledgeReason.trim()) {
        this.error = "Observation is required";
        return;
      }
      this.onEmployeeSubmit(2);
      this.showAknModal = false;
    },
    submitComplete() {
      if (!this.selectedReview.acknowledgeReason || !this.selectedReview.acknowledgeReason.trim()) {
        this.error = "Observation is required";
        return;
      }
      this.onEmployeeSubmit(7);
      this.showAknModal = false;
    },
    onEmployeeSubmit(status) {
      if (!this.selectedReview) {
        this.error = "Review not loaded yet";
        return;
      }
      if (
        confirm(
          "After submission, you cannot edit the changes.Do you want to proceed?"
        )
      ) {
        this.selectedReview.status = status ? status : 2;

        performanceService.updateReviewByHr(this.selectedReview.id, this.selectedReview).then(
          m => {
            alert("Review have been updated successful");
            this.getReviews();
          },
          error => {
            alert(error);
          }
        );
      }
    },
    onDelete () {
        performanceService.removeGoal(this.goal.id)
        .then(
            model => {
                this.getGoals();
                this.closeDelete()
            }
        )
    },
    openDelete(item) {
        this.goal = item
        this.dialogDelete = true
    },
    closeDelete() {
      this.dialogDelete = false;
      // this.clearModel();
    },
    loadManagers() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      if (!unit) {
        this.error = "Unable to load managers - unit not set";
        return;
      }
      employeeService.getManagers(unit.id).then(
        model => {
          this.managers = model;
          console.log("managers", model);
        },
        error => {
          this.error = error;
        }
      );
    },
    openAssignOther(item) {
      this.selectedReview = item;
      this.declinedReason = item.declinedReason || "";
      this.selectedManagerName = null;
      this.selectedManagerId = null;
      this.dialogAssignOther = true;
    },
    closeAssignOther() {
      this.dialogAssignOther = false;
      this.selectedReview = null;
      this.selectedManagerName = null;
      this.selectedManagerId = null;
      this.declinedReason = "";
    },
    nameOfManager({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },
    optionSelectedManager(option) {
      this.selectedManagerId = option.id;
      this.selectedManagerName = option;
    },
    submitAssignOther() {
      if (!this.selectedReview) {
        this.error = "No selected review to assign.";
        return;
      }
      if (!this.selectedManagerId) {
        this.error = "Please select a manager to assign.";
        return;
      }

      this.submitted = true;
      this.selectedReview.otherId = this.selectedManagerId;
      this.selectedReview.status = 6;

      performanceService.updateReviewByHr(this.selectedReview.id, this.selectedReview).then(
        _ => {
          this.message = "Other manager assigned successfully.";
          this.dialogAssignOther = false;
          this.getReviews();
          this.submitted = false;
        },
        error => {
          this.error = error;
          this.submitted = false;
        }
      );
    },
  },
  name: "addGoalActivity"
};
</script>
<style scoped>
.datelay {
    z-index: 100;
}

.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/review/hrReviews.vue